import { Inject, Injectable } from '@angular/core';
import * as _ from 'lodash';
import { combineLatest, Observable, of, timer } from 'rxjs';
import {
  catchError,
  exhaustMap,
  map,
  shareReplay,
  switchMap,
} from 'rxjs/operators';
import { DestinationsProvider } from '@prlw/core/destinations/destinations.provider';
import { AllInstruments } from '@prlw/core/monitor/all-instruments.entity';
import { AllTableModifiersService } from '@prlw/core/monitor/all-table-modifiers.service';
import {
  MONITOR_GATEWAY,
  MonitorGateway,
} from '@prlw/core/monitor/monitor.gateway';
import { ShipmentsProvider } from '@prlw/core/shipments/shipments.provider';
import { ProductGroupsService } from '../products/product-groups.service';
import {
  IObservableWithPending,
  observableWithPending,
} from '@prlw/infrastructure/observableWithPending';

const TICKER_INTERVAL = 5000;

@Injectable({
  providedIn: 'root',
})
export class AllTableInstrumentsService {
  public readonly allInstruments$: Observable<IObservableWithPending<
    AllInstruments[]
  > | null>;

  constructor(
    @Inject(MONITOR_GATEWAY) private readonly gateway: MonitorGateway,
    destinationsProvider: DestinationsProvider,
    productGroupsService: ProductGroupsService,
    shipmentsProvider: ShipmentsProvider,
    private readonly allTableModifiersService: AllTableModifiersService,
  ) {
    // !!! ?????
    // this.allTableModifiersService
    //     .updateModifier(ModifierType.BASIC)
    //     .subscribe();
    this.allInstruments$ = combineLatest([
      productGroupsService.productGroups$.pipe(
        map((products) => _.map(products, 'code')),
      ),
      destinationsProvider.currentDestination$,
      shipmentsProvider.shipmentsByAllProductGroup$.pipe(
        map((shipments) => _.map(shipments, 'code')),
      ),
      this.allTableModifiersService.modifier$,
    ]).pipe(
      switchMap(([productGroupCodes, destination, shipmentCodes, modifiers]) =>
        timer(0, TICKER_INTERVAL).pipe(
          exhaustMap((tick) => {
            if (tick === 0) {
              return observableWithPending(
                this.gateway.getAllInstruments(
                  productGroupCodes,
                  shipmentCodes,
                  destination?.id ?? '',
                  modifiers,
                ),
              );
            }
            return this.gateway
              .getAllInstruments(
                productGroupCodes,
                shipmentCodes,
                destination?.id ?? '',
                modifiers,
              )
              .pipe(
                map((allInstruments) => ({
                  done: true,
                  pending: false,
                  result: allInstruments,
                })),
                catchError((error) =>
                  of({
                    done: true,
                    pending: false,
                    error,
                  }),
                ),
              );
          }),
        ),
      ),
      shareReplay({
        bufferSize: 1,
        refCount: true,
      }),
    );
  }
}
